<template>
  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
    <template v-if="loading">
      <div v-for="i in 5" :key="i" class="bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-24 mb-4"></div>
        <div class="h-8 bg-gray-200 rounded w-32 mb-3"></div>
        <div class="h-5 bg-gray-200 rounded w-20"></div>
      </div>
    </template>
    <div v-else-if="error" class="col-span-full bg-red-50 border border-red-200 rounded-xl p-4 flex items-center justify-between">
      <span class="text-sm text-red-600">{{ error }}</span>
      <button @click="refresh" class="text-sm text-red-700 font-medium hover:underline">Reessayer</button>
    </div>
    <template v-else-if="data">
      <KpiCard
        v-for="kpi in kpis"
        :key="kpi.key"
        :label="kpi.label"
        :value="kpi.value"
        :evolution="kpi.evolution"
        :format="kpi.format"
        :icon="kpi.icon"
        :color="kpi.color"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import KpiCard from './KpiCard.vue'

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/kpi/invoicing', dateParams)

const kpis = computed(() => {
  if (!data.value) return []
  const d = data.value
  return [
    { key: 'total_invoices', label: 'Total factures', value: d.total_invoices?.current, evolution: d.total_invoices?.evolution, format: 'integer', icon: 'file-invoice' },
    { key: 'paid_invoices', label: 'Factures payees', value: d.paid_invoices?.current, evolution: d.paid_invoices?.evolution, format: 'integer', icon: 'file-circle-check' },
    { key: 'unpaid_invoices', label: 'Factures impayees', value: d.unpaid_invoices?.current, evolution: d.unpaid_invoices?.evolution, format: 'integer', icon: 'exclamation-triangle', color: 'red' },
    { key: 'total_amount', label: 'Montant total', value: d.total_amount?.current, evolution: d.total_amount?.evolution, format: 'currency', icon: 'money-bill-wave' },
    { key: 'average_amount', label: 'Montant moyen', value: d.average_amount?.current, evolution: d.average_amount?.evolution, format: 'currency', icon: 'calculator' }
  ]
})
</script>
